import { useEffect, useRef, useState } from 'react'

type Timeout = ReturnType<typeof setTimeout>

export function useDebouncedProperty<T>(
  propertyValue: T,
  changePropertyValue: (value: T) => void,
  delay = 2000,
) {
  const [value, setValue] = useState(propertyValue)
  const timeoutRef = useRef<Timeout | null>()

  useEffect(() => setValue(propertyValue), [propertyValue])

  const onChange = (value: T) => {
    setValue(value)
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    timeoutRef.current = setTimeout(() => changePropertyValue(value), delay)
  }

  return [value, onChange] as const
}
